// reducers/shiftSwapReducer.js

import * as actionTypes from '../actions/types';

const initialState = {
    loading: false,
    approveSuccess: false,
    rejectSuccess: false,
    message: '',
    error: null,
    data: null
};

const shiftSwapReducer = (state = initialState, action) => {
    switch (action.type) {
        // APPROVE
        case actionTypes.APPROVE_SWAP_REQUEST:
            return {
                ...state,
                loading: true,
                approveSuccess: false,
                error: null
            };

        case actionTypes.APPROVE_SWAP_SUCCESS:
            return {
                ...state,
                loading: false,
                approveSuccess: true,
                message: action.payload.message,
                data: action.payload.data,
                error: null
            };

        case actionTypes.APPROVE_SWAP_FAILURE:
            return {
                ...state,
                loading: false,
                approveSuccess: false,
                error: action.payload.error,
                message: ''
            };

        // REJECT
        case actionTypes.REJECT_SWAP_REQUEST:
            return {
                ...state,
                loading: true,
                rejectSuccess: false,
                error: null
            };

        case actionTypes.REJECT_SWAP_SUCCESS:
            return {
                ...state,
                loading: false,
                rejectSuccess: true,
                message: action.payload.message,
                data: action.payload.data,
                error: null
            };

        case actionTypes.REJECT_SWAP_FAILURE:
            return {
                ...state,
                loading: false,
                rejectSuccess: false,
                error: action.payload.error,
                message: ''
            };

        // CLEAR
        case actionTypes.CLEAR_SWAP_MESSAGE:
            return {
                ...state,
                approveSuccess: false,
                rejectSuccess: false,
                message: '',
                error: null
            };

        default:
            return state;
    }
};

export default shiftSwapReducer;